import { useFileLocalPreviewUrl } from "@tellescope/react-hooks";
import { FileImagePreview } from "./FileImagePreview";
import { FilePreviewTile } from "./FilePreviewTile";

interface FileLocalItemPreviewProps {
  file: File;
}

export const FileLocalItemPreview = ({ file }: FileLocalItemPreviewProps) => {
  const previewUrl = useFileLocalPreviewUrl(file);

  if (!previewUrl) {
    return <FilePreviewTile />;
  }

  return <FileImagePreview src={previewUrl} alt={file.name} />;
};
